import HandymanRoundedIcon from "@mui/icons-material/HandymanRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import axios from "axios";
import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import { NavLink, useParams } from "react-router-dom";
import Feed from "./Feed";
import BidAssistantHero from "./BidAssistantHero";
import BidFlowJourney from "./BidFlowJourney";
import Footer from "./Footer";
import Rightbar from "./Rightbar";
import UpdatesBar from "./UpdatesBar";
import { trackEventOnce } from "../asset/js/analytics";

function Home() {
  const { search } = useParams();

  const topRef = useRef(null);
  const [news, setNews] = useState([]);

  const search1 = search ?? "no";

  useEffect(() => {
    trackEventOnce("homepage_view", "home");
    // Remove window.location.reload().
    // Reloading allows the browser to restore the previous scroll position.
    if (localStorage.getItem("reload") === "1") {
      localStorage.setItem("reload", "2");
    }

    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/getnews`)
      .then((res) => {
        setNews(res.data?.News || []);
      })
      .catch((err) => {
        console.error("Failed to load news:", err);
      });
  }, []);

  return (
    <Box
      ref={topRef}
      sx={{
        fontFamily: process.env.REACT_APP_FONT,
        scrollMarginTop: 0,
        minHeight: "100dvh",
        background:
          "linear-gradient(180deg, #F7FAFD 0%, #FFFFFF 42%, #F8FBFE 100%)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1500px",
          mx: "auto",
          px: { xs: 1, sm: 2, lg: 3 },
          pt: { xs: 1, md: 2 },
        }}
      >
        <BidAssistantHero />
        <BidFlowJourney />

        <Box
          dir="rtl"
          sx={{
            mb: { xs: 2, md: 2.5 },
            px: { xs: 1.5, sm: 2.2 },
            py: { xs: 1.35, sm: 1.55 },
            display: "flex",
            alignItems: { xs: "stretch", sm: "center" },
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1.2,
            borderRadius: "18px",
            bgcolor: "#FFFFFF",
            border: "1px solid #DCEAF5",
            boxShadow: "0 8px 24px rgba(24, 83, 126, .07)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.15 }}>
            <Box sx={{ width: 42, height: 42, flexShrink: 0, display: "grid", placeItems: "center", borderRadius: "13px", color: "#FFFFFF", background: "linear-gradient(145deg, #FFB347, #F28A12)" }}>
              <HandymanRoundedIcon />
            </Box>
            <Box>
              <Typography sx={{ fontFamily: "Assistant", fontWeight: 900, color: "#173B57", fontSize: { xs: 16, sm: 18 } }}>
                בעלי מקצוע? יש לנו עבודות בשבילכם
              </Typography>
              <Typography sx={{ fontFamily: "Assistant", color: "#667F91", fontSize: { xs: 13, sm: 14 } }}>
                ההרשמה והגשת ההצעות בחינם
              </Typography>
            </Box>
          </Box>
          <Button component={NavLink} to="/proflandingpage" variant="contained" sx={{ minHeight: 44, px: 2.4, borderRadius: "12px", fontFamily: "Assistant", fontWeight: 900, textTransform: "none", whiteSpace: "nowrap", bgcolor: "#1976D2", boxShadow: "0 7px 18px rgba(25,118,210,.18)", "&:hover": { bgcolor: "#1268BB" } }}>
            הרשמה כבעל מקצוע
          </Button>
        </Box>

        <Stack
          className="App"
          spacing={{ xs: 2, lg: 3 }}
          direction={{ xs: "column", lg: "row" }}
          alignItems="flex-start"
          sx={{ fontFamily: process.env.REACT_APP_FONT }}
        >
          <Feed search1={search1} />

          {news.length > 0 && <Rightbar news={news} />}
        </Stack>
        <UpdatesBar news={news} />
      </Box>

      <Footer />
    </Box>
  );
}

export default Home;
